import { render, staticRenderFns } from "./PriceListStep.vue?vue&type=template&id=0f2f0889&scoped=true"
import script from "./PriceListStep.vue?vue&type=script&lang=js"
export * from "./PriceListStep.vue?vue&type=script&lang=js"
import style0 from "./PriceListStep.vue?vue&type=style&index=0&id=0f2f0889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f0889",
  null
  
)

export default component.exports